// src/pages/markets/board/board/SharedFiltersDialog.tsx

import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography,
} from '@mui/material';
import type { BoardFilters, ColumnId } from '../api/boardTypes';
import { describeFilters } from '../state/boardShareLink';
import { SectionLabel } from '../../../../components/common/page/SectionLabel';
import { KEEP_DIALOG_SIZE } from '../../../../root/touchTheme';

export interface SharedFiltersDialogProps {
    open: boolean;
    columns: { id: ColumnId; title: string; filters: Partial<BoardFilters> }[];
    onSave: () => void;
    onDismiss: () => void;
}

export function SharedFiltersDialog({
    open,
    columns,
    onSave,
    onDismiss,
}: SharedFiltersDialogProps) {
    return (
        <Dialog
            open={open}
            onClose={onDismiss}
            maxWidth="xs"
            fullWidth
            className={KEEP_DIALOG_SIZE}
        >
            <DialogTitle sx={{ fontSize: '15px', fontWeight: 700 }}>Save filters</DialogTitle>

            <DialogContent dividers>
                <Typography sx={{ fontSize: '12px', color: 'text.secondary', mb: 1.5 }}>
                    This link set the following filters. They are applied now. Save them to keep
                    them after a reload.
                </Typography>

                {columns.map(col => (
                    <Box key={col.id} sx={{ mb: 1.5 }}>
                        <SectionLabel sx={{ mb: 0.5 }}>{col.title}</SectionLabel>
                        {describeFilters(col.filters).map(line => (
                            <Typography
                                key={line}
                                sx={{ fontSize: '12px', color: 'text.primary', lineHeight: 1.6 }}
                            >
                                {line}
                            </Typography>
                        ))}
                    </Box>
                ))}
            </DialogContent>

            <DialogActions>
                <Button size="small" onClick={onDismiss} sx={{ fontSize: '12px' }}>
                    Ok
                </Button>
                <Button size="small" variant="contained" onClick={onSave} sx={{ fontSize: '12px' }}>
                    Save
                </Button>
            </DialogActions>
        </Dialog>
    );
}